// outros-resources-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "% bateriam": "% alcanzarían",
    "'Identfid'": "'Identfid'",
    "(vazio)": "(vacío)",
    "* Selecione uma rede na barra de ferramentas acima": "* Seleccione una red en la barra de herramientas de arriba",
    ". O": ". El",
    ". Para mudar, ajuste lá e depois clique em": ". Para cambiar, ajuste allá y luego haga clic en",
    "A competência é o mês do vencimento no Gestão Click": "El mes de facturación es el mes del vencimiento en Gestão Click",
    "Abrir no Gestão Click": "Abrir en Gestão Click",
    "Adicionar CNPJ na exclusão": "Agregar CNPJ en la exclusión",
    "Adicionar cidade": "Agregar ciudad",
    "Adicionar frentista": "Agregar playero",
    "Alterado por": "Modificado por",
    "Alterar": "Modificar",
    "Analisando dados de": "Analizando datos de",
    "Análise baseada em": "Análisis basado en",
    "Ao confirmar, será realizado um novo envio para este cliente.": "Al confirmar, se realizará un nuevo envío para este cliente.",
    "Ao confirmar, será realizado um novo envio para todos os clientes que possuem status de erro. Totalizando": "Al confirmar, se realizará un nuevo envío para todos los clientes que tienen estado de error. Totalizando",
    "Arquivos de NFe": "Archivos de NFe",
    "Atualizar Cobranças": "Actualizar Cobros",
    "Atualizar Status": "Actualizar Estado",
    "Avaliação do Posto": "Evaluación de la Estación",
    "Ações": "Acciones",
    "Belo Horizonte - MG": "Belo Horizonte - MG",
    "CPF do cliente": "CPF del cliente",
    "CPF:": "CPF:",
    "Cadastrar envio em massa": "Registrar envío masivo",
    "Cadastrar usuário frentista": "Registrar usuario playero",
    "Campo": "Campo",
    "Carregador": "Cargador",
    "Cliente que efetuou a troca:": "Cliente que realizó el canje:",
    "Clientes Ignorados": "Clientes Ignorados",
    "Cobrança do cliente": "Cobro del cliente",
    "Com meta de": "Con objetivo de",
    "Combustíveis Alvo (Numerador)": "Combustibles Objetivo (Numerador)",
    "Combustíveis Base (Denominador)": "Combustibles Base (Denominador)",
    "Competência": "Mes de facturación",
    "Comprovante": "Comprobante",
    "Comprovante de pagamento": "Comprobante de pago",
    "Configurações salvas com sucesso": "Configuración guardada con éxito",
    "Conflito entre registros": "Conflicto entre registros",
    "Criar fatura": "Crear factura",
    "Criar grupo de clientes": "Crear grupo de clientes",
    "Cupom": "Cupón",
    "Cupom estornado com sucesso!": "¡Cupón revertido con éxito!",
    "Cupom já foi estornado!": "¡Cupón ya fue revertido!",
    "Cupom já resgatado!": "¡Cupón ya canjeado!",
    "Cupom:": "Cupón:",
    "Código do carregador": "Código del cargador",
    "Data de Troca:": "Fecha de Canje:",
    "Data de criação": "Fecha de creación",
    "Data de geração": "Fecha de generación",
    "Data de pagamento": "Fecha de pago",
    "Data de pagamento é obrigatório": "La fecha de pago es obligatoria",
    "Data do resgate": "Fecha del canje",
    "Data/Hora": "Fecha/Hora",
    "Data:": "Fecha:",
    "Desfecho": "Resultado",
    "Dias de inatividade para entrar": "Días de inactividad para entrar",
    "Editar Cobrança": "Editar Cobro",
    "Editar Fatura": "Editar Factura",
    "Editar cidade": "Editar ciudad",
    "Editar empresa sem pontuação": "Editar empresa sin puntuación",
    "Editar frentista": "Editar playero",
    "Editar grupo de clientes": "Editar grupo de clientes",
    "Editar usuário frentista": "Editar usuario playero",
    "Email verificado": "Email verificado",
    "Energia": "Energía",
    "Envio em massa": "Envío masivo",
    "Envios em massa": "Envíos masivos",
    "Erro ao baixar arquivo": "Error al descargar el archivo",
    "Erro ao buscar configurações atuais": "Error al buscar la configuración actual",
    "Erro ao realizar o reenvio": "Error al realizar el reenvío",
    "Erro ao salvar configurações": "Error al guardar la configuración",
    "Excluir usuário": "Eliminar usuario",
    "Falha no registro de pagamento!": "¡Error en el registro de pago!",
    "Fator Valor/Litro": "Factor Valor/Litro",
    "Forçar usuário a trocar senha no primeiro acesso": "Forzar al usuario a cambiar la contraseña en el primer acceso",
    "Funcionário": "Empleado",
    "Gasto máximo total R$ (opcional)": "Gasto máximo total R$ (opcional)",
    "ID": "ID",
    "ID Gestão Click": "ID Gestão Click",
    "ID da entidade": "ID de la entidad",
    "Identificador": "Identificador",
    "Identificador do cupom": "Identificador del cupón",
    "Identifid": "Identifid",
    "Ignorado por": "Ignorado por",
    "Incluir NFe (Não adicionar boletos! A PontuaX não se responsabiliza pelos arquivos enviados.)": "Incluir NFe (¡No agregar boletos! PontuaX no se responsabiliza por los archivos enviados.)",
    "Link de convite": "Enlace de invitación",
    "Local": "Lugar",
    "Login": "Login",
    "Login (email)": "Login (email)",
    "Loja (Gestão Click)": "Tienda (Gestão Click)",
    "Meta (%)": "Objetivo (%)",
    "Máximo de clientes por ciclo (opcional)": "Máximo de clientes por ciclo (opcional)",
    "Método de pagamento": "Método de pago",
    "Mês do vencimento no Gestão Click": "Mes del vencimiento en Gestão Click",
    "Mínimo": "Mínimo",
    "Nenhum dado encontrado para os postos e período selecionados. Verifique se os frentistas possuem tag cadastrada e se há abastecimentos registrados.": "No se encontraron datos para las estaciones y el período seleccionados. Verifique que los playeros tengan una etiqueta registrada y que haya cargas de combustible registradas.",
    "Nome da Regra": "Nombre de la Regla",
    "Nome:": "Nombre:",
    "Novidade: agora usamos Etiquetas.": "Novedad: ahora usamos Etiquetas.",
    "Novo valor": "Nuevo valor",
    "Não definido": "No definido",
    "Não foi possível verificar a disponibilidade do Identfid": "No fue posible verificar la disponibilidad del Identfid",
    "Número da fatura": "Número de factura",
    "Número de envios": "Número de envíos",
    "O envio de SMS está sujeito a": "El envío de SMS está sujeto a",
    "O mês acompanha a": "El mes sigue la",
    "O status está sendo atualizado": "El estado se está actualizando",
    "Observação da Rede": "Observación de la Red",
    "Observação do Parceiro": "Observación del Socio Comercial",
    "Os grupos deram lugar às etiquetas — mais flexíveis, porque um mesmo cliente pode ter": "Los grupos dieron lugar a las etiquetas — más flexibles, porque un mismo cliente puede tener",
    "PDF": "PDF",
    "Pagar": "Pagar",
    "Pagar Fatura": "Pagar Factura",
    "Para uma experiência ainda melhor, recomendamos que o posto tenha integração com a software house de PDV (Ponto de Venda). Com a integração ativa, o desconto é aplicado automaticamente no momento do abastecimento, proporcionando mais agilidade e praticidade para seus clientes, sem a necessidade de importações manuais.": "Para una experiencia aún mejor, recomendamos que la estación de servicio tenga integración con la software house de PDV (Punto de Venta). Con la integración activa, el descuento se aplica automáticamente en el momento de la carga de combustible, brindando más agilidad y practicidad para sus clientes, sin necesidad de importaciones manuales.",
    "Parceiro": "Socio Comercial",
    "Parceiro / Revenda": "Socio Comercial / Revendedor",
    "Pontuadas": "Puntuadas",
    "Produto:": "Producto:",
    "Recargas elétricas": "Recargas eléctricas",
    "Recuperar": "Recuperar",
    "Reenviar": "Reenviar",
    "Reenviar para todos que estão com status de erro": "Reenviar a todos los que tienen estado de error",
    "Reenvio": "Reenvío",
    "Reenvio em andamento. Por favor, aguarde e recarregue a página para verificar o status.": "Reenvío en curso. Por favor, espere y recargue la página para verificar el estado.",
    "Reenvio em massa": "Reenvío masivo",
    "Reenvio realizado.": "Reenvío realizado.",
    "Registro de pagamento realizado com sucesso!": "¡Registro de pago realizado con éxito!",
    "Regra de recuperação criada com sucesso": "Regla de recuperación creada con éxito",
    "Request ID": "Request ID",
    "Sem desfecho": "Sin resultado",
    "Senha": "Contraseña",
    "Sessões": "Sesiones",
    "Status Cliente": "Estado Cliente",
    "Status Parceiro": "Estado Socio Comercial",
    "Status de envio": "Estado de envío",
    "Sugestão de Meta": "Sugerencia de Objetivo",
    "Usuário frentista": "Usuario playero",
    "Usuários frentistas": "Usuarios playeros",
    "Usuários frentistas deletados": "Usuarios playeros eliminados",
    "Valor anterior": "Valor anterior",
    "Valor do Parceiro": "Valor del Socio Comercial",
    "Valor do boleto": "Valor del boleto",
    "Valor total": "Valor total",
    "Valor:": "Valor:",
    "Vencimento": "Vencimiento",
    "Você está prestes a enviar mensagens em massa. Este envio será realizado instantaneamente e não poderá ser desfeito. Por favor, verifique as informações cuidadosamente antes de prosseguir.": "Está a punto de enviar mensajes masivos. Este envío se realizará de forma instantánea y no podrá deshacerse. Por favor, verifique la información cuidadosamente antes de continuar.",
    "Webhook": "Webhook",
    "clientes": "clientes",
    "clientes selecionados": "clientes seleccionados",
    "cobranças": "cobros",
    "custo aumenta": "costo aumenta",
    "data de vencimento do recebimento no Gestão Click": "fecha de vencimiento del cobro en Gestão Click",
    "de": "de",
    "dias": "días",
    "dias...": "días...",
    "etiquetas (antes era só um grupo). Crie e gerencie tudo em": "etiquetas (antes era solo un grupo). Cree y gestione todo en",
    "já está em uso por um registro de frentista. Se você prosseguir com o cadastro, o registro abaixo será excluído e o novo registro passará a utilizar o mesmo código.": "ya está en uso por un registro de playero. Si continúa con el registro, el registro de abajo será eliminado y el nuevo registro pasará a utilizar el mismo código.",
    "no relatório de cobranças. O mês aqui é reescrito a partir do ERP a cada sincronização — alterar só deste lado não tem efeito.": "en el reporte de cobros. El mes aquí se reescribe a partir del ERP en cada sincronización — modificarlo solo de este lado no tiene efecto.",
    "nos últimos": "en los últimos",
    "número de clientes": "número de clientes",
    "proporcionalmente ao": "proporcionalmente al",
    "selecionados. Verifique a lista de destinatários e esteja ciente dos custos adicionais.": "seleccionados. Verifique la lista de destinatarios y tenga en cuenta los costos adicionales.",
    "teriam atingido a meta": "habrían alcanzado el objetivo",
    "várias": "varias",
    "· últimos": "· últimos",
    "Último Abastecimento": "Última carga de combustible",
    "últimos": "últimos",
    "💡 Recomendação: Integração com PDV": "💡 Recomendación: Integración con PDV",
};

export default catalogo;
